import type { components } from '@/generated/profile.js';
import { authService } from '@/services/auth.js';

export type UserProfile = components['schemas']['UserProfile'];
export type UpdateUserRequest = components['schemas']['UpdateUserRequest'];

class ProfileClient {
    private async _authHeaders(): Promise<Record<string, string>> {
        await authService.ensureValidToken();
        return { Authorization: `Bearer ${authService.getToken()!}` };
    }

    async getProfile(): Promise<UserProfile> {
        const res = await fetch('/api/profile/v1/user', {
            headers: await this._authHeaders()
        });
        if (!res.ok) throw new Error(`Failed to load profile: ${res.status}`);
        return res.json();
    }

    async getEntitlements(): Promise<Record<string, boolean>> {
        const res = await fetch('/api/profile/v1/user/entitlements', {
            headers: await this._authHeaders()
        });
        if (!res.ok) throw new Error(`Failed to load entitlements: ${res.status}`);
        return res.json();
    }

    async updateProfile(userName: string): Promise<UserProfile> {
        const body: UpdateUserRequest = { userName };
        const res = await fetch('/api/profile/v1/user', {
            method: 'PUT',
            headers: { ...await this._authHeaders(), 'Content-Type': 'application/json' },
            body: JSON.stringify(body)
        });
        if (!res.ok) throw new Error(`Failed to update profile: ${res.status}`);
        return res.json();
    }
}

export const profileClient = new ProfileClient();